// src/pages/admin/user-details.tsx
import { Outlet, useLocation, useNavigate, useParams, Navigate, Link } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { useMemo } from 'react'

export default function UserDetailsPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  if (!id) return <Navigate to="/admin/usuarios" replace />

  const currentTab = useMemo(() => {
    const segs = pathname.split('/').filter(Boolean)
    return segs[3] ?? 'permissoes'
  }, [pathname])

  return (
    <div className="mx-auto">
      <div className="flex items-center justify-between py-2">
        <Link to="/admin/usuarios" replace>
          <Button variant="outline" className="flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" /> Voltar
          </Button>
        </Link>

        <Tabs value={currentTab} onValueChange={v => navigate(`/admin/usuarios/${id}/${v}`)}>
          <TabsList className="flex gap-2">
            <TabsTrigger value="permissoes">Permissões</TabsTrigger>
            <TabsTrigger value="editar">Editar</TabsTrigger>
          </TabsList>
        </Tabs>

        <div className="w-[146px]" />
      </div>

      <Outlet />
    </div>
  )
}
